<div class="card card-block page-card">
    <form>
        <div class="form-row">
            <model-property-view class="col-md-4 mb-3"
                propertyName="Customer Name"
                [(propertyValue)]="customer.Name"
                editable="true"
                (valueChange)="onChangeDetails($event)"
            ></model-property-view>
            <model-property-view class="col-md-4 mb-3"
                propertyName="Customer ID"
                [propertyValue]="customerId"
            ></model-property-view>
            <model-property-view class="col-md-4 mb-3"
                propertyName="Serial Number"
                [(propertyValue)]="customer.SerialNumber"
                editable="true"
                (valueChange)="onChangeDetails($event)"
            ></model-property-view>
        </div>
        <div class="form-row">
            <model-property-view class="col-md-4 mb-3"
                propertyName="Location"
                [(propertyValue)]="customer.OrganizationLocation"
                editable="true"
                (valueChange)="onChangeDetails($event)"
            ></model-property-view>
            <model-property-view class="col-md-4 mb-3"
                propertyName="Email"
                [(propertyValue)]="customer.Email"
                editable="true"
                (valueChange)="onChangeDetails($event)"
            ></model-property-view>
            <model-property-view class="col-md-4 mb-3"
                propertyName="Contact Number"
                [(propertyValue)]="customer.ContactNumber"
                editable="true"
                (valueChange)="onChangeDetails($event)"
            ></model-property-view>
        </div>
        <div class="form-row">
            <div class="mb-3" [ngClass]="{'col-md-4': customer.SiteOnline, 'col-md-8': !customer.SiteOnline}">
                <label>AU Groups</label>
                <div class="form-control form-control-div">{{customerGroups}}</div>
            </div>
            <div class="col-md-4 mb-3" *ngIf="customer.SiteOnline">
                <label>Online ML Site</label>
                <input type="text" class="form-control btn-link cursor-pointer" value="{{customer.SiteOnline.Url}}" readonly (click)="goToLink(customer.SiteOnline.Url)">
            </div>
            <model-property-view class="col-md-4 mb-3"
                propertyName="Sales Force Link"
                [(propertyValue)]="customer.SalesforceLink"
                editable="true"
                linked="true"
                (valueChange)="onChangeDetails($event)"
                (linkClicked)="onSalesForceLinkClick($event)"
            >
                <div class="input-group-append cursor-pointer" (click)="onVerify()" tooltip="Verify">
                    <div *ngIf="!customer.IsVerified" class="input-group-text border-danger text-danger"><span class="fa fa-exclamation-circle"></span></div>
                    <div *ngIf="customer.IsVerified" class="input-group-text border-success text-success"><span class="fa fa-check-circle"></span></div>
                </div>

            </model-property-view>
        </div>
    </form>
    <hr>
    <tabset>
        <tab heading="Requests" [active]="activeTabId === 'requests'" (selectTab)="onSelectTab($event)" id='requests'>
            <app-customer-page-requests [customerId]="customerId"></app-customer-page-requests>
        </tab>
        <tab heading="Update History" [active]="activeTabId === 'updates'" (selectTab)="onSelectTab($event)" id='updates'>
            <app-customer-page-updates [customerId]="customerId"></app-customer-page-updates>
        </tab>
        <tab heading="Current State" [active]="activeTabId === 'state'" (selectTab)="onSelectTab($event)" id='state'>
            <app-customer-page-state [customerId]="customerId"></app-customer-page-state>
        </tab>
        <tab heading="Self-Update" [active]="activeTabId === 'selfupdate'" (selectTab)="onSelectTab($event)" id='selfupdate'>
            <app-customer-page-selfupdate [customerId]="customerId"></app-customer-page-selfupdate>
        </tab>
        <tab *ngIf="isTestEvironment()" heading="Support" [active]="activeTabId === 'support'" (selectTab)="onSelectTab($event)" id='support'>
            <app-customer-page-support [customerId]="customerId"></app-customer-page-support>
        </tab>
    </tabset>
    <hr/>
    <form class="form-inline">
        <!-- <button type="button" class="btn btn-light mr-2" (click)="onVerify()">Verify</button> -->
        <div class="mr-auto"></div>
        <button type="button" class="btn btn-light" [routerLink]="['../..']">Close</button>
    </form>
</div>
